import { Row, Spin } from "antd";
import React, { Suspense } from "react";

// export const CustomSpinner = () => {
//     return (
//         <svg className="circular" viewBox="25 25 50 50">
//             <circle className="path" cx="50" cy="50" r="20" fill="none" strokeWidth="2" strokeMiterlimit="10" />
//         </svg>
//     );
// };
 

/**
 * Use this for lazy loading components WITH props (modals, widgets, etc.)
 */
// export const LazyLoader = <T extends React.ComponentType<any>>(
//   importFunc: () => Promise<{ default: T }>
// ): React.FC<React.ComponentProps<T>> => {
//   const LazyComponent = React.lazy(importFunc);

//   const ComponentWithSuspense = (props: React.ComponentProps<T>) => (
//     <Suspense
//       fallback={
//         // <div>
//         // </div>
//         <Loader />
//       }
//     >
//       <LazyComponent {...props} />
//     </Suspense>
//   );

//   return ComponentWithSuspense;
// };


{/* <Spin spinning indicator={<CustomSpinner />}/> */}
/**
 * Use this to wrap <Routes> and lazy-loaded pages.
 */
export const LazyWrapper = ({ children }: { children: React.ReactNode }) => (
  <Suspense
    fallback={
            <Row justify="center" align="middle" style={{ height: '100vh', width: '100vw' }}>
                <Spin spinning wrapperClassName="tp-custom-spin h-100" />
            </Row>
    }
  >
    {children}
  </Suspense>
);

/**
 * Use this for simple page-level lazy loading (routes) without props.
 * MUST wrap all <Routes> with <LazyWrapper> when using this.
 */
export const LazyPage = (
  importFunc: () => Promise<{ default: React.ComponentType<any> }>
) => React.lazy(importFunc);

// export default LazyLoader;
